// extracted by mini-css-extract-plugin
export default {"stack":"Refund_stack__4xGpq","terms":"Refund_terms__C+ot8"};